"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Common_Function_1 = require("../../../utils/Common.Function");
// import FieldPhoneCountry from "../utils/Field.PhoneCountry";
const type_1 = require("../../../type");
const Field_Constant_1 = require("../utils/Field.Constant");
const Field_Function_1 = require("../utils/Field.Function");
const FieldPhoneNumber = ({ props }) => {
    var _a, _b;
    const [open, setOpen] = React.useState(false);
    const [country, setCountry] = React.useState("");
    const [phone, setPhone] = React.useState("");
    const [loading, setLoading] = React.useState(true);
    const [trigger, setTrigger] = React.useState(false);
    const isDisabled = typeof props.disabled === type_1.TYPE_FUNCTION
        ? props.disabled(props)
        : props.disabled;
    React.useEffect(() => {
        if (country && phone) {
            props.setValue(`+${country}${phone}`);
        }
        else {
            props.setValue("");
        }
    }, [phone, country]);
    // const defaultOptions = FieldPhoneCountry;
    const defaultOptions = [];
    let options = [];
    React.useEffect(() => {
        if (props.defualtValue && !props.value && !loading) {
            setCountry(props.defualtValue);
        }
        else {
            return;
        }
    }, [props.defualtValue, loading]);
    React.useEffect(() => {
        if (!trigger) {
            setTimeout(() => {
                if (props.value) {
                    const findCountry = (0, Field_Function_1.FunctionCheckLoadPhoneNumberCountry)(options, props.value);
                    if (findCountry === null || findCountry === void 0 ? void 0 : findCountry.country) {
                        setCountry(findCountry.country);
                        setPhone(findCountry.phone);
                        setTrigger(true);
                    }
                    else {
                        setLoading(false);
                    }
                }
                else {
                    setLoading(false);
                }
                setLoading(false);
            }, 1000);
        }
        else {
            return;
        }
    }, [props.value]);
    if (props.select.length > 0) {
        const all = (0, Common_Function_1.FunctionSelectArray)(defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.map((item) => {
            return item.code;
        }), props.select);
        all.map((item) => {
            options.push(defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.find((i) => {
                return i.code === item;
            }));
        });
    }
    if (props.select.length <= 0) {
        options = defaultOptions;
    }
    const found = options.find((i) => {
        return i.value === country;
    });
    if (loading) {
        return React.createElement("div", null, "...");
    }
    else {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-input ${props.classNameOptions}`, style: {
                    display: "flex",
                } },
                React.createElement(React.Fragment, null,
                    React.createElement("div", { style: {
                            position: "relative",
                            paddingLeft: "1rem",
                            paddingRight: "1rem",
                            paddingTop: "0.5rem",
                            paddingBottom: "0.5rem",
                            borderRight: "1px solid #e0e0e0",
                            width: "150px",
                        } },
                        React.createElement("div", { style: {
                                display: "flex",
                                justifyContent: "space-between",
                            } },
                            found ? (React.createElement("img", { style: {
                                    width: "30px",
                                    height: "20px",
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                }, onClick: (e) => {
                                    e.stopPropagation();
                                    if (isDisabled) {
                                        return;
                                    }
                                    else {
                                        setTimeout(() => {
                                            setCountry("");
                                            setOpen(true);
                                        }, 150);
                                    }
                                }, src: (_a = options === null || options === void 0 ? void 0 : options.find((option) => {
                                    return option.value === country;
                                })) === null || _a === void 0 ? void 0 : _a.image })) : (React.createElement("div", { style: {
                                    width: "30px",
                                    height: "20px",
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                }, onClick: () => {
                                    if (isDisabled) {
                                        return;
                                    }
                                    else {
                                        setOpen(!open);
                                    }
                                } })),
                            React.createElement("div", { style: {
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                } }, "+"),
                            React.createElement("input", { className: `${Field_Constant_1.TEXT_AUTHOR}-value ${props.classNameValue}`, style: {
                                    width: "50px",
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                    paddingLeft: "0.5rem",
                                    paddingRight: "0.5rem",
                                }, value: country, onChange: ({ target: { value } }) => {
                                    setOpen(true);
                                    const thisNumber = (0, Common_Function_1.FunctionGetNumberFromString)(value);
                                    setCountry(thisNumber);
                                }, onFocus: () => {
                                    setOpen(true);
                                }, onBlur: () => {
                                    setTimeout(() => {
                                        setOpen(false);
                                    }, [100]);
                                }, onKeyPress: (e) => {
                                    if (e.key === "Enter") {
                                        setOpen(false);
                                    }
                                } })),
                        open && !isDisabled && (React.createElement("div", { style: {
                                position: "absolute",
                                top: "100%",
                                height: "128px",
                                overflowY: "scroll",
                            } }, (_b = options === null || options === void 0 ? void 0 : options.filter((i) => {
                            return i.value !== country && i.value.includes(country);
                        })) === null || _b === void 0 ? void 0 : _b.map((option, index) => {
                            return (React.createElement("img", { onClick: () => {
                                    setCountry(option.value);
                                    setOpen(false);
                                }, key: `key-option-${index}`, style: {
                                    width: "30px",
                                    height: "20px",
                                }, src: option === null || option === void 0 ? void 0 : option.image }));
                        }))))),
                React.createElement("input", { id: props.name, className: `${Field_Constant_1.TEXT_AUTHOR}-input ${props.classNameInput}`, disabled: isDisabled, value: phone, name: props.name, placeholder: props.placeholder, onChange: (e) => {
                        const value = e.target.value;
                        const thisNumber = (0, Common_Function_1.FunctionGetNumberFromString)(value);
                        setPhone(thisNumber);
                    }, ref: (event) => {
                        props.reference.current = event;
                    } }))));
    }
};
exports.default = FieldPhoneNumber;
